import { Application, Controller } from "stimulus"

export default class CollapsibleController extends Controller {

  static targets = [ "collapsible", "collapsibleContent" ]

  toggleCollapsible() {
    this.collapsibleTarget.classList.toggle('gw-collapsible-active')
    if (this.collapsibleContentTarget.style.maxHeight){
      this.collapsibleContentTarget.style.maxHeight = null;
    } else {
      this.collapsibleContentTarget.style.maxHeight = this.collapsibleContentTarget.scrollHeight;
    } 
  }
}

const application = Application.start()
application.register("collapsible", CollapsibleController)

